// نظام فحص الصلاحيات
import { BarChart3, Users, MessageSquare, FileText, Layout, Settings, UserCog, Tag, Mail } from 'lucide-react';

// خريطة الأيقونات
const iconMap = {
  'BarChart3': BarChart3,
  'Users': Users,
  'MessageSquare': MessageSquare,
  'FileText': FileText,
  'Layout': Layout,
  'Settings': Settings,
  'UserCog': UserCog,
  'Tag': Tag,
  'Mail': Mail
};

// فحص الدور
export const checkRole = (user, roles) => {
  if (!user) return false;
  const allowedRoles = Array.isArray(roles) ? roles : [roles];
  return allowedRoles.includes(user.role);
};

// فحص الصلاحية
export const checkPermission = (user, permission) => {
  if (!user) return false;
  if (user.role === 'admin') return true; // المدير له جميع الصلاحيات
  return user.permissions && user.permissions.includes(permission);
};

// الحصول على الصفحات المسموحة للمستخدم
export const getAllowedPages = (user) => {
  if (!user) return [];
  
  const pages = [];
  
  // 1- لوحة التحكم (جميع المستخدمين)
  pages.push({
    name: 'Dashboard',
    name_ar: 'لوحة التحكم',
    path: '/dashboard',
    icon: 'BarChart3'
  });
  
  // 2- العملاء (الجميع ما عدا المحرر والمشاهد)
  if (!['editor', 'viewer'].includes(user.role)) {
    pages.push({
      name: 'Clients',
      name_ar: 'العملاء',
      path: '/clients',
      icon: 'Users'
    });
  }
  
  // 3- فئات العملاء (الجميع ما عدا المحرر والمشاهد)
  if (!['editor', 'viewer'].includes(user.role)) {
    pages.push({
      name: 'Client Categories',
      name_ar: 'فئات العملاء',
      path: '/client-categories',
      icon: 'Tag'
    });
  }
  
  // 4- قوالب البريد (المدير فقط)
  if (user.role === 'admin') {
    pages.push({
      name: 'Email Templates',
      name_ar: 'قوالب البريد',
      path: '/email-templates',
      icon: 'Layout'
    });
  }
  
  // 5- الرسائل (الجميع ما عدا المشاهد)
  if (user.role !== 'viewer') {
    pages.push({
      name: 'Messages',
      name_ar: 'الرسائل',
      path: '/messages',
      icon: 'MessageSquare'
    });
  }
  
  // 6- التقارير (الجميع ما عدا المحرر)
  if (user.role !== 'editor') {
    pages.push({
      name: 'Reports',
      name_ar: 'التقارير',
      path: '/reports',
      icon: 'FileText'
    });
  }
  
  // 7- الإعدادات العامة (الجميع)
  pages.push({
    name: 'Settings',
    name_ar: 'الإعدادات العامة',
    path: '/settings',
    icon: 'Settings'
  });
  
  // 8- إدارة المستخدمين (المدير فقط)
  if (user.role === 'admin') {
    pages.push({
      name: 'User Management',
      name_ar: 'إدارة المستخدمين',
      path: '/users',
      icon: 'UserCog'
    });
  }
  
  // 9- إعدادات SMTP (الجميع)
  pages.push({
    name: 'SMTP Settings',
    name_ar: 'إعدادات SMTP',
    path: '/email-test',
    icon: 'Mail'
  });
  
  return pages;
};

// خريطة الصلاحيات المطلوبة لكل صفحة
export const PAGE_PERMISSIONS = {
  '/': [], // الصفحة الرئيسية متاحة للجميع
  '/dashboard': [], // لوحة التحكم متاحة للجميع
  '/clients': ['admin', 'manager', 'user'], // العملاء (الجميع ما عدا المحرر والمشاهد)
  '/clients/create': ['admin', 'manager', 'user'],
  '/clients/edit': ['admin', 'manager', 'user'],
  '/client-categories': ['admin', 'manager', 'user'], // فئات العملاء (الجميع ما عدا المحرر والمشاهد)
  '/email-templates': ['admin'], // قوالب البريد (المدير فقط)
  '/messages': ['admin', 'manager', 'user', 'editor'], // الرسائل (الجميع ما عدا المشاهد)
  '/messages/create': ['admin', 'manager', 'user', 'editor'],
  '/messages/edit': ['admin', 'manager', 'user', 'editor'],
  '/reports': ['admin', 'manager', 'user', 'viewer'], // التقارير (الجميع ما عدا المحرر)
  '/settings': [], // الإعدادات العامة (الجميع)
  '/users': ['admin'], // إدارة المستخدمين (المدير فقط)
  '/email-test': [] // إعدادات SMTP (الجميع)
};

// فحص الصلاحية للصفحة
export const checkPagePermission = (user, path) => {
  if (!user) return false;
  
  // البحث عن أطول مسار مطابق
  const matchingPaths = Object.keys(PAGE_PERMISSIONS).filter(pagePath => 
    path.startsWith(pagePath) && pagePath !== '/'
  );
  
  const longestMatch = matchingPaths.reduce((longest, current) => 
    current.length > longest.length ? current : longest, '/'
  );
  
  const requiredRoles = PAGE_PERMISSIONS[longestMatch] || [];
  
  // إذا لم تكن هناك صلاحيات مطلوبة، الصفحة متاحة للجميع
  if (requiredRoles.length === 0) return true;
  
  // فحص دور المستخدم
  return requiredRoles.includes(user.role);
};

export { iconMap };
